<h2 mat-dialog-title>{{ titolo }}</h2>
<mat-dialog-content>
  <mat-checkbox [(ngModel)]="ckInformativa">
    Ho preso visione
    <a [href]="linkInformativa" target="_blank">dell’informativa</a>
    {{ testoInformativa }}
  </mat-checkbox>
</mat-dialog-content>
<div mat-dialog-actions class="action_buttons">
  @if (showButtonNo) {
    <button mat-button color="primary" mat-dialog-close (click)="chiudiDialog(0)">
      {{ buttonNoText ? buttonNoText : 'No' }}
    </button>
  }
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-flat-button color="primary" (click)="chiudiDialog(1)" [disabled]="!ckInformativa">
    {{ buttonOkText }}
  </button>
</div>
